import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__global_reset } from '@/state/_base/LOCAL__global_reset';
import { remote_user_auth_logout } from '@/state/user/auth/remote_user_auth_logout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function S_BUTTON__logout() {
  const dispatch = use_dispatch();

  const navigate = useNavigate();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  async function onClick(event: React.MouseEvent<HTMLButtonElement>): Promise<void> {
    dispatch(LOCAL__global_reset());

    await dispatch(remote_user_auth_logout());

    await navigate(ENUM__page_type.AUTH);
  }

  return (
    <UI_PRIMITIVE__button className="w-56" variant="outline-on-component" {...{ onClick }}>
      <span className="text-danger">{t(i18n_page_settings_user.tabs.account.button.logout)}</span>
    </UI_PRIMITIVE__button>
  );
}
